function OurTeam() {
  return (
    <>
      <div className="page-title" data-aos="fade">
        <div className="container">
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Our Team</li>
            </ol>
          </nav>
          <h1>Our Team</h1>
        </div>
      </div>

      <section id="our-team" className="team section">
        <div className="container">
          <p>
            At CA Sanjay Prasad & Associates, our strength lies in our people. Our team comprises dedicated professionals with deep expertise across accounting, auditing, taxation, legal advisory, and financial consultancy. Together, we are committed to delivering exceptional service and personalized solutions that empower our clients.
          </p>

          <div className="team-grid">
            <div className="team-member">
              <img src="/assets/img/team/team-member1.png" alt="CA Sanjay Prasad" />
              <h3>CA Sanjay Prasad</h3>
              <p>Founder & Managing Partner</p>
              <p>Expert in audit, taxation, and strategic advisory with over 15 years of experience.</p>
            </div>

            <div className="team-member">
              <img src="/assets/img/team/team-member2.png" alt="CA Priya Mehta" />
              <h3>Priya Kumari</h3>
              <p>Senior Tax Consultant</p>
              <p>Specializes in direct & indirect taxes and corporate tax litigation.</p>
            </div>

            <div className="team-member">
              <img src="/assets/img/team/team-member1.png" alt="Ravi Sharma" />
              <h3>Ravi Sharma</h3>
              <p>GST & Compliance Head</p>
              <p>Experienced in GST filing, advisory, and regulatory compliance.</p>
            </div>

            {/* Add more team members as needed */}
          </div>
        </div>
      </section>
    </>
  );
}

export default OurTeam;
